module.exports = __webpack_public_path__ + "static/media/AdivinaElNumero_cover.05abd5ed.png";